// extracted by mini-css-extract-plugin
export default {"wrapper":"xQ-z","ratingContainer":"yQ-z","ratingValue":"zQ-z","starSprite":"AQ-z","ratingLabel":"BQ-z","error":"CQ-z","errorBox":"DQ-z"};